module.exports = __webpack_public_path__ + "img/introduce_space.5de6068b.jpg";